import React from 'react';

const PriceDropIcon = () => {
  return (
    <div className="price-drop-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <circle
          cx="8"
          cy="8"
          r="7.5"
          stroke="#C8102E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.89355 5.71436V10.3053"
          stroke="#C8102E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0625 8.58252L7.89376 10.7918L5.71484 8.58252"
          stroke="#C8102E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default PriceDropIcon;
